import { render } from "./PendingCaseTestTubesView.vue?vue&type=template&id=1f91191e&scoped=true"
import script from "./PendingCaseTestTubesView.vue?vue&type=script&lang=js"
export * from "./PendingCaseTestTubesView.vue?vue&type=script&lang=js"

import "./PendingCaseTestTubesView.vue?vue&type=style&index=0&id=1f91191e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f91191e"],['__file',"src/components/pendingCases/PendingCaseTestTubesView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f91191e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f91191e', __exports__)) {
    console.log('reload')
    api.reload('1f91191e', __exports__)
  }
  
  module.hot.accept("./PendingCaseTestTubesView.vue?vue&type=template&id=1f91191e&scoped=true", () => {
    console.log('re-render')
    api.rerender('1f91191e', render)
  })

}


export default __exports__